import { ReferenceArea, ReferenceLine } from "recharts";

// Shared "nyt" marker: a dimmed history band + a dashed reference line, consistent with the
// Trendi panel's now-cursor (TrendView.tsx).
//
// A plain function called inline (`{nowMarker({...})}`) that returns an array, not a component
// and not a Fragment: Recharts 2 only draws the reference/graphical children it finds by
// scanning the chart's own `children` — it flattens arrays but renders neither an unknown
// component type nor the contents of a Fragment — so a `<NowMarker />` element was silently
// dropped and the marker never appeared.
export function nowMarker({
  x,
  firstX,
  yAxisId,
}: {
  x: number;
  firstX: number;
  yAxisId?: string;
}) {
  return [
    <ReferenceArea
      key="now-band"
      x1={firstX}
      x2={x}
      yAxisId={yAxisId}
      fill="var(--muted-foreground)"
      fillOpacity={0.06}
    />,
    <ReferenceLine
      key="now-line"
      x={x}
      yAxisId={yAxisId}
      stroke="var(--destructive)"
      strokeWidth={1.5}
      strokeDasharray="4 4"
      label={{
        value: "NYT",
        position: "insideTopRight",
        fill: "var(--destructive)",
        fontSize: 9,
        fontWeight: 700,
      }}
    />,
  ];
}
